import { IconButton, TextField } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { Contact, NewCustomer } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { AddItemPlusButton } from 'apps/app/src/components/design/buttons/AddItemPlusButton';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { CustomerViewPropertiesBlock } from '../../CustomerInfoViewEditPage/customer-info-view-edit-components/CustomerViewPropertiesBlock';

type CustomerContactWithId = Contact & {
  id: number;
};
export const CreateCustomerContactsBlock: React.FC = () => {
  const { control, formState: { errors } } = useFormContext<NewCustomer>();
  
  const { fields: contacts, append: appendContact, remove: removeContact } = useFieldArray({  
    control,
    name: 'contacts',
  });
  
  const handleAddRow = () => {
    const newCustomerContact = buildCustomerContactWithId(contacts.length + 1, '', '');
    appendContact(newCustomerContact);
  };

  const handleRemoveRow = (index: number) => {
    removeContact(index);
  };
  
  return (
    <CustomerViewPropertiesBlock
      titleClassName='text-xl text-black font-medium'
      childrenContainerClassName='flex flex-col gap-6'
      title='Contact'
    >
      <div className="flex flex-col gap-y-4">
        {contacts.map((field, index) => (
          <div
            className='flex w-full gap-6'
            key={field.id}
          >
            <div>
              <Controller
                name={`contacts.${index}.name`}
                control={control}
                render={({ field: nameField }) => (
                  <TextField
                    label="Contact Name"
                    placeholder="Text here"
                    {...nameField}
                    error={isNotNullOrUndefined(errors.contacts?.[index]?.name)}
                    helperText={errors.contacts?.[index]?.name?.message}
                  />
                )}
              />
            </div>
            <div>
              <Controller
                name={`contacts.${index}.email`}
                control={control}
                render={({ field: emailField }) => (
                  <TextField
                    label="Contact Email"
                    placeholder="Email here"
                    {...emailField}
                    error={isNotNullOrUndefined(errors.contacts?.[index]?.email)}
                    helperText={errors.contacts?.[index]?.email?.message}
                  />
                )}
              />
            </div>
            <div className='flex items-start mt-8'>
              <IconButton
                onClick={() => handleRemoveRow(index)}
              >
                <VyIcon icon='Truncate'/>
              </IconButton>
            </div>
          </div>
        ))}
      </div>

      <AddItemPlusButton
        onClick={handleAddRow}
        title='Add Contact'
      />
    </CustomerViewPropertiesBlock>
  );
};

function buildCustomerContactWithId(id: number, name: string, email: string): CustomerContactWithId {
  return { id, name, email };
}